import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {useQueryResponseData, useQueryResponseLoading, useQueryResponsePagination} from '../core/QueryResponseTemplosProvider'
import {templosColumns} from './columns/_columns'
import {Templo} from '../core/_models'
import {GenericListLoading} from '../components/loading/GenericListLoading'
import {TemplosListPagination} from '../components/pagination/TemplosListPagination'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import { TemploRow } from './columns/TemploRow'
import { TemploHeaderColumn } from './columns/TemploHeaderColumn'

const TemplosTable = () => {
  const templos = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const pagination = useQueryResponsePagination()
  const data = useMemo(() => templos, [templos])
  const columns = useMemo(() => templosColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Templo>) => (
                <TemploHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Templo>, i) => {
                prepareRow(row)
                return <TemploRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    Nenhum registro correspondente encontrado
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className='d-flex justify-content-between align-items-center my-3'>
        <div className='text-muted'>
          {(pagination?.total ?? 0) > 0 ? (
            <>
              Total de <strong>{(pagination?.total ?? 0).toLocaleString('pt-BR')}</strong> templo(s) encontrado(s)
            </>
          ) : (
            <>Nenhum templo encontrado</>
          )}
        </div>
      </div>
      <TemplosListPagination />
      {isLoading && <GenericListLoading />}
    </KTCardBody>
  )
}

export {TemplosTable}
